import { Component, Input } from '@angular/core';
import { SparePartStatus } from '../../../../features/result/spare-parts-result/spare-parts.interface';

@Component({
    selector: 'ecs-inventory-indicator',
    templateUrl: './inventory-indicator.component.html',
    styleUrls: ['./inventory-indicator.component.scss'],
    imports: [],
})
export class InventoryIndicatorComponent {
    @Input() public status?: SparePartStatus;

    public SparePartStatus = SparePartStatus;
}
